export default "__VITE_ASSET__Bgs$7aIC__"